import { render, staticRenderFns } from "./batchChildModule.vue?vue&type=template&id=18b1a092&scoped=true"
import script from "./batchChildModule.vue?vue&type=script&lang=js"
export * from "./batchChildModule.vue?vue&type=script&lang=js"
import style0 from "./batchChildModule.vue?vue&type=style&index=0&id=18b1a092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1a092",
  null
  
)

export default component.exports